module.exports = __webpack_public_path__ + "static/media/21ECLAC24.f2ab1b48.jpg";